import { usePlanDetailContext } from '@aibees/shared/features/price-and-plan/components/plan-detail/context';
import { classnames, toNumber } from '@aibees/shared/utils';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { DataPointsCheckboxGroup } from './components/data-points-checkbox-group';
import { FormFields } from './components/form-fields';
import * as Styled from './styles';
import * as SX from './sx';
import type { DialogLeftSideProps as Props } from './types';

export const DialogLeftSide = memo(({ className }: Props) => {
  const {
    leads,
    setLeads,
    meetings,
    setMeetings,
    validWorkEmail,
    mobilePhoneNumber,
    fullProfileEnrichment,
    calculate,
    leadsError,
    meetingsError,
    ticksError,
  } = usePlanDetailContext();

  return (
    <Styled.Wrapper
      className={classnames('DialogLeftSide', className)}
      sx={SX.root}
    >
      <Stack gap={1}>
        <Card variant="outlined" sx={SX.card}>
          <CardContent padding="extra" sx={SX.cardContent}>
            <Stack gap={1}>
              <Typography variant="body2" fontWeight={700} color="grey.700">
                Contacts
              </Typography>

              <FormFields
                label="How many new leads will you target per month?*"
                value={leads}
                onChange={(e) => setLeads(toNumber(e.target.value))}
                error={leadsError}
              />
              <DataPointsCheckboxGroup error={ticksError} />
            </Stack>
          </CardContent>
        </Card>
        <Card variant="outlined" sx={SX.card}>
          <CardContent padding="extra" sx={SX.cardContent}>
            <Stack gap={1}>
              <Typography variant="body2" fontWeight={700} color="grey.700">
                AI Personality Sales Analysis
              </Typography>
              <FormFields
                label="How many sales meeting do you expect per month?*"
                value={meetings}
                onChange={(e) => setMeetings(toNumber(e.target.value))}
                error={meetingsError}
              />
            </Stack>
          </CardContent>
        </Card>
      </Stack>
      <Button
        variant="contained"
        color="primary"
        onClick={calculate}
        size="small"
        disabled={
          !leads ||
          !meetings ||
          !(
            validWorkEmail.value ||
            mobilePhoneNumber.value ||
            fullProfileEnrichment.value
          )
        }
      >
        Calculate
      </Button>
    </Styled.Wrapper>
  );
});

DialogLeftSide.displayName = 'DialogLeftSide';
